import React from 'react';
import BaseView from '../../components/CRUDView';
import Utils, {exportFilteredCSV} from '../../common/Utils';
import {TractorOperatorEndpoint, TractorOwnerEndpoints} from "../../common/ProxyEndpoints";
import Avatar from '../../components/ProfileAvatar';
import EntityImageDisplay from "../../components/EntityImageDisplay/EntityImageDisplay";
import OperatorUtils from "./OperatorUtils";
import {Dialogs, Gender, GenderMap, Permissions} from "../../common/Constants";
import {user} from 'react-icons-kit/entypo/user';
import HistoryLink from "../../common/HistoryLink";
import {Badge} from 'reactstrap';
import DialogCollapseSection from "../../components/DialogCollapseSection/DialogCollapseSection";
import 'react-table/react-table.css';
import {
    getInputs as GetInputs,
    OPERATORS_QUERY_FILTERS,
    OperatorsCustomFilterView,
    parseOperatorsQueryFilters
} from './OperatorCommon';
import OperationSummaryComponent, {FixedValueDisplay} from "../../components/OperationSummaryComponent/OperationSummaryComponent";
import AppVariables from "../../common/AppVariables";
import _ from "lodash";
import CreateTractorDialog from "../../components/CreateTractorDialog/CreateTractorDialog";
import {OperatorRegistrationDialog} from "./OperatorRequests";
import RatingView from "./RatingView";
import WorkloadComponent from "../Tractors/WorkloadComponent";
import {broadcastEvent} from "../../common/Events/EventSource";
import EventActions from "../../common/Events/Actions";
import {ChangeServiceProviderDialog} from "../Tractorowners/ChangeServiceProviderDialog";
import {getActiveQuantityInfo, getQuantityUnit, getQuantityValue} from "../../common/QuantityHelper";

const SearchProps = [
    'name',
    'phone',
    'email',
    'address',
    'license',
    'owner.name',
    'tractor.name',
    'tractor.tractor_model',
    'tractor.chassis',
    'tractor.registration_number'
];

const CacheDependency = [
    'tractor_owners',
    'dashboard'
];



/**
 * Handles management of tractor operators by administrators
 */
class OperatorsAdmin extends BaseView {

    constructor(props){
        super(props, 'operators_admin');
        this.fetchTractorOwners = this.fetchTractorOwners.bind(this);
        this.fetchOwnerTractors = this.fetchOwnerTractors.bind(this);
    }

    /**
     * Fetches all tractors for the operator
     */
    fetchOwnerTractors( ownerId, idleOnly , exclude , include){

        //  already loaded
        if(this.state.tractorSource == ownerId){
            return Promise.resolve();
        }

        this.setState({
            isBusy: true,
            tractorSource: ownerId
        });

        const me = this;

        return OperatorUtils.fetchOwnerTractors(ownerId,idleOnly,exclude,include).then(tractors =>{

            //  force update
            me.state.tractors = tractors;

            me.setState({
                tractors: tractors
            });

        }).catch(err => {

            //  show error and allow retry


        }).then(() => {

            me.setState({
                isBusy: false
            });

        });


    }

    fetchRequests(operator,range,customInfo){

        const me = this;

        this.setState({
            isBusy: true
        });

        //  get requests for operator
        return this.proxy.processRequest(TractorOperatorEndpoint.getOperationSummary(operator.id,range,customInfo)).then(response => {

            operator.operationSummary = response.getPayload();

            me.setState({
                summaryError: null,
                detailItem: operator,
                isBusy: false
            });

        }).catch(err => {

            me.setState({
                isBusy: false,
                summaryError: err
            });

        });
    }

    beginShowDetails(operator){

        //  relay to base view
        super.beginShowDetails(operator);

        //  fetch requests assigned to operator
        this.fetchRequests(operator);
    }

    beforeCloseDialog(dialog){

        if(dialog == Dialogs.CreateOrEdit){

            this.setState({
                tractors: null,
                tractorSource: null
            });

        }

    }

    fetchTractorOwners(){

        //  fetch tractor owners
        return this.proxy.processRequest(TractorOwnerEndpoints.getUrl(), {
            fields: ['id', 'name'],
            include: [ 'user' , 'media' ],
            method: 'get'
        });

    }

    renderDialogs(dialog){

        return <div>

                {super.renderDialogs(dialog)}

                <ChangeServiceProviderDialog ref={r => this._changeServiceProviderDlg = r}/>

                <CreateTractorDialog ref={r => this._createTractorDlg = r}
                                     includeOwner
                                     onExit={() => this.refresh()}/>

                <OperatorRegistrationDialog ref={r => this._regOperatorsDlg = r}
                                            owners={this.state.owners}
                                            tractors={this.state.tractors}
                                            fetchOwnerTractors={this.fetchOwnerTractors}
                                            fetchTractorOwners={this.fetchTractorOwners}/>
            </div>;

    }

    getCustomFilterState(filters) {
        return parseOperatorsQueryFilters(filters);
    }

    componentWillMount(){

        const me = this;

        this.setViewOptions({

            //  The message to show when there are no items in the view
            noRowsMessage: 'No tractor operators available yet!',

            //  The class icon for the card header
            pageIcon: 'fa fa-user',

            //  The title for the content frame
            pageTitle: 'Tractor Operators',

            //  The total number of items per page
            maxItemsPerPage: 10,

            //  Defines the features of the view
            features: [ 'toolbox' , 'search' ],

            multiSelection: {

                //  enable multi-selection
                enable : true,
            },

            //  defines (CRUD) actions enabled on the items
            actions:{

                //  create action options
                create: {
                    enabled: true,
                    text: 'Add Operator',
                    successCreateMsg: 'Operator added successfully!',
                    failCreateMsg : 'Failed creating operator!',
                    editTitleMsg: 'Edit Operator',
                    createTitleMsg: 'Add Operator',
                    permissions:  [ Permissions.Operators.Create ]
                },

                //  delete action options
                delete:{

                    enabled : true,

                    //  Disallows the deleting of many items ??
                    disallowMany: false,

                    successDeleteMsg: 'Deleted operator successfully!',
                    failDeleteMsg: 'Failed deleting operator',
                    text: 'Delete',
                    confirmTitle: 'Confirm Delete',
                    confirmMessage: 'Are you sure you want to delete operator?',

                    //  The message to show when deleting many items
                    confirmManyMessage: 'Delete selected operators?',
                    permissions:  [ Permissions.Operators.Remove ]
                },

                //  delete action options
                edit:{
                    enabled : true,
                    successEditMsg: 'Edited operator successfully!',
                    failEditMsg: 'Failed editing operator',
                    text: 'Edit',
                    permissions:  [ Permissions.Operators.Update ]
                }

            },

            queryActions: {
                endpoint: TractorOperatorEndpoint.getUrl()
            },

            filters: OPERATORS_QUERY_FILTERS,

            renderCustomFilters: (props) => <OperatorsCustomFilterView includeOwner {...props}/>,

            search: {

                //
                placeholder: 'Search operators...',

                //  the mode for searching
                //  immediate: responsive
                //  explicit: wait till user hits the search button
                mode: 'explicit',

                //  The minimum characters to begin search with
                minSearchChars: 2,

                //  The search properties
                properties: SearchProps

            },

            sort: {

                properties: [
                    {
                        label: "Date Added",
                        value: "date_created"
                    },
                    {
                        label: "Name",
                        value: "name"
                    },
                    {
                        label: "Phone",
                        value: "phone"
                    }
                ]
            },

            //  Defines actions for toolbox
            toolBox: [

                //  ACTIONS
                {  text : 'Add operator'  , icon : 'fa fa-plus'  , invoke: () => {me.beginShowDialog({ activeDialog: 0 }); }  , position: 'right' , permissions:  [ Permissions.Operators.Create ] },
                {  text : 'Refresh'  , icon : 'fa fa-refresh'  ,
                    invoke: () => {

                        //  refresh view
                        me.refresh();

                        //  broadcast event for child components
                        broadcastEvent(EventActions.RefreshActivePage);

                    } ,
                    position: 'right'
                },
                {  text : 'Gender'  , icon : 'fa fa-male' , invoke: (index) => { me.updateQuery('sex',index) } , position: 'right' , group : 'filter' , items: GenderMap },
                {  text : null  , icon : 'fa fa-sort' , invoke: (index) => { me.configureSort();  }, position: 'right' , group : 'filter'},
                {  text: 'USSD Registrations' , icon: 'fa fa-archive' , invoke: () => me._regOperatorsDlg.show() , position: 'left' },
                {  text : ''  , icon : 'fa fa-gears' , invoke: (index) => {
                    switch (index){
                        case 0:
                            me._regOperatorsDlg.show();
                            break;
                        case 1:
                            return exportFilteredCSV(TractorOperatorEndpoint.exportCSV(),{ component: me });
                        case 2:
                            return  me.toggleCustomFilterVisibility();
                    }
                }, position: 'right' , group : 'filter' ,
                    items: () => ([
                        "Registered Operators (USSD)",
                        <span><i className="fa fa-file-text"/> Export to CSV</span>,
                        <span><i className={me.isCustomFilterViewVisible() ? "fa fa-chevron-up" : "fa fa-chevron-down"}/> {me.isCustomFilterViewVisible() ? "Hide" : "Show"} Advanced Filters</span>
                    ]),
                    sticky: false,
                },
            ],

            model: {
                include: [ 'owner' , 'tractor' , 'media' ]
            },

            hooks:{

                //  Called before every query to get items
                preQueryHook: () => {

                    return me.fetchTractorOwners().then(response =>{

                        return {
                            owners: response.getPayload()
                        };

                    });

                },

                postProcessorHook: (action,response) =>{
                    Utils.eraseSession(CacheDependency);
                },

                renderCellActions: (item) => {

                    let actions = [
                        {
                            //  Show tractor requests
                            label: "View Requests" , icon: 'fa fa-eye' , onClick: () => {
                                return Utils.navigateLink(`/requests?tractor_operator=${encodeURIComponent(item.id.toString())}&_operator_select_name=${encodeURIComponent(item.name)}`)
                            }
                        },
                        {
                            label: "Change Service Provider", icon: "fa fa-exchange", onClick: () => {

                                this._changeServiceProviderDlg.show({
                                    entity: 'operator',
                                    id: item.id,
                                    owner: item.owner_id,
                                    onChange: () => this.updateItemSingle(item.id)
                                });

                            }
                        }
                    ];

                    if(_.isNil(item.tractor)){

                         actions.push({
                             label: "Register Tractor",
                             icon: "fa fa-plus",
                             onClick: () => {
                                 return this._createTractorDlg.show({ operator: item , owner: item.owner })
                             }
                         });

                    }


                    return actions;
                }

            },

            //  Inputs used in editing and creating items
            inputs: () => {

                return GetInputs({
                    editItem: this.state.editItem,
                    owners: this.state.owners,
                    tractors: this.state.tractors,
                    fetchOwnerTractors: this.fetchOwnerTractors.bind(this),
                    refreshTractorOwners: this.fetchTractorOwners.bind(this),
                    formRenderer: () => this.getDialogRenderer(Dialogs.CreateOrEdit)
                });

            } ,

            // Describes the columns present in the table
            columns : [
                {key: '__img' , label: ' ' , cell: (item,k) => <Avatar media={item.media} name={Utils.formatAvatarName(item.name)} size={32} /> , mobile: true },
                {key:  'name', label: () => me.sortCol('Name','name') , mobile: true },
                {key:  'owner', label: 'Employer' , format: (owner) => owner ? owner.name : null },
                {key:  'phone', label: () => me.sortCol('Phone No.',"phone") , mobile: true },
                {key:  'tractor', label:'Tractor' , format: (tractor) => tractor ? Utils.formatTractorName(tractor,false,false) : <h6><Badge pill={true}>Unassigned</Badge></h6> , mobile: true  },
                {key: 'workload', label: 'Workload' , cell: item => <WorkloadComponent operator={item}/> },
            ],

            //  Describes details to show when clicked
            detailsDisplay: {

                //  enable or disable
                enabled: true,

                renderTitle: () => {
                    return "Operator Info";
                },

                renderActions: (item,  { toggle }) => ([
                    {
                        label: "View Requests" , icon: "fa fa-eye", color: "success", onClick: () => {
                            toggle();
                            return Utils.navigateLink(`/requests?tractor_operator=${encodeURIComponent(item.id.toString())}&_operator_select_name=${encodeURIComponent(item.name)}`)
                        }
                    }
                ]),

                customRender : (item) => {

                    const me = this;

                    return <div>

                        <div className="text-center">
                            <h5>Profile Image</h5>
                            <EntityImageDisplay
                                entityName="operator"
                                entityId={item.id}
                                crudView={me}
                                onRemove={(media) => {
                                    me.updateItemMedia(item,media);
                                }}
                                onCompleteUpload={(media) => {
                                    me.updateItemMedia(item,media);
                                    return false;
                                }}
                                media={item.media} />

                        </div>

                        <div>

                            <DialogCollapseSection title={"Info"} initiallyOpen={true}>
                                <hr/>
                                <div className="row">
                                    <div className="col-md-6">
                                        <dl>

                                            <dt>Name</dt>
                                            <dl>{item.name}</dl>

                                            <dt>Phone</dt>
                                            <dl>{item.phone}</dl>

                                            <dt>Address</dt>
                                            <dl>{Utils.standardValue(item.address)}</dl>

                                            <dt>Date Registered</dt>
                                            <dl>{Utils.formatDateStandard(item.date_created)}</dl>

                                        </dl>
                                    </div>
                                    <div className="col-md-6">
                                        <dl>

                                            <dt>Gender</dt>
                                            <dl>{item.sex != null ? GenderMap[item.sex] : "N/A" }</dl>

                                            <dt>Tractor Owner</dt>
                                            <dl><HistoryLink url={`/tractor_owners?filter_id=${item.owner.id}&q=${item.owner.name}`} className="btn-link" tooltip="Click to see tractor owner">{item.owner.name}</HistoryLink></dl>

                                            <dt>Assigned Tractor</dt>
                                            <dl>{item.tractor ? <HistoryLink url={`/tractors?filter_id=${item.tractor.id}&q=${item.tractor.chassis}`} className="btn-link" tooltip="Click to see tractor">{Utils.formatTractorName(item.tractor)}</HistoryLink> : "N/A"}</dl>

                                            <dt>License Class(es)</dt>
                                            <dl>{item.license ? item.license.split(",").sort().map((m,index) => <Badge pill={true} key={index} style={{marginRight: 5}}>{m}</Badge>) : null} </dl>


                                        </dl>
                                    </div>
                                </div>
                            </DialogCollapseSection>


                            <hr/>

                            <RatingView operatorId={item.id}/>

                            <hr/>

                            <OperationSummaryComponent
                                operationSummary={item.operationSummary}
                                onQuery={(timeRange,rangeInfo) => me.fetchRequests(item,timeRange,rangeInfo)}
                                renderRevenueStats={summary => (<div className="row">

                                    <div className="col-md-6 text-center">
                                        <h6><Badge pill color={"info"}>Pending <i className="fa fa-chevron-up"/></Badge></h6>
                                        <FixedValueDisplay id="total_pending_income"
                                                           value={summary.totalPendingIncome}
                                                           message={AppVariables.CurrencyCode}
                                                           hint="Indicates revenue to be generated from assigned requests"/>

                                    </div>

                                    <div className="col-md-6 text-center">

                                        <h6><Badge pill color={"success"}>Completed <i className="fa fa-chevron-down"/></Badge></h6>

                                        <FixedValueDisplay id="total_completed_income"
                                                           value={summary.totalIncome}
                                                           message={AppVariables.CurrencyCode}
                                                           hint="Shows total revenue generated from completed requests"/>

                                    </div>

                                </div>)}
                                renderOperationStats={summary => (<div className="row">

                                    <div className="col-md-4 text-center">
                                        <h6><Badge pill color={"danger"}>Cancelled <i className="fa fa-close"/></Badge></h6>
                                        <FixedValueDisplay id="total_cancelled_requests"
                                                           value={summary.totalCancelledRequests}
                                                           hint="Shows to total number of requests cancelled within the given time specified"/>
                                    </div>


                                    <div className="col-md-4 text-center">
                                        <h6><Badge pill color={"info"}>Assigned <i className="fa fa-chevron-up"/></Badge></h6>
                                        <FixedValueDisplay id="total_assigned_acres"
                                                           value={getQuantityValue(summary, { acre: 'totalAcresAssigned' , hectare: 'totalHectaresAssigned' })}
                                                           message={getQuantityUnit( getQuantityValue(summary, { acre: 'totalAcresAssigned' , hectare: 'totalHectaresAssigned' }) ).toLowerCase()}
                                                           hint={`Shows total ${getActiveQuantityInfo().plural.toLowerCase()} assigned to the operator over the time range specified`}/>
                                    </div>

                                    <div className="col-md-4 text-center">
                                        <h6><Badge pill >Completed <i className="fa fa-chevron-down"/></Badge></h6>
                                        <FixedValueDisplay id="total_completed_acres"
                                                           value={getQuantityValue(summary, { acre: 'totalAcresCompleted' , hectare: 'totalHectaresCompleted' })}
                                                           message={getQuantityUnit( getQuantityValue(summary, { acre: 'totalAcresCompleted' , hectare: 'totalHectaresCompleted' }) ).toLowerCase()}
                                                           hint={`Shows completed ${getActiveQuantityInfo().plural.toLowerCase()} within specified time`}/>
                                    </div>

                                </div>)}/>




                        </div>

                    </div>
                }

            },

            //  Processors
            processors :{

                //  create new item
                createItem: (proxy , payload ) => {

                    //  create tractor operator
                     return proxy.processRequest( TractorOperatorEndpoint.createOperator( payload.owner , payload.tractor , {
                         name: payload.name,
                         phone: payload.phone,
                         address: payload.address,
                         address_lat: payload.address_lat,
                         address_long: payload.address_long,
                         license: payload.license,
                         sex: payload.sex
                    }));

                },

                //  called to delete many items
                deleteMany: (proxy,items) => {
                    return proxy.processRequest(TractorOperatorEndpoint.deleteOperator(items.map((i) => i.id)));
                },

                //  on edit item
                onEditItem: (proxy,item, payload , affected ) => {

                    affected.owner_id = affected.owner;
                    affected.tractor_id = payload.tractor || null;

                    //  remove unwanted props
                    delete affected.tractor;
                    delete affected.owner;

                    //  check for changed parameters
                    if(Object.keys(affected).find(x => affected[x] !== undefined)) {

                        affected.last_updated = item.last_updated;
                        return proxy.processRequest(TractorOperatorEndpoint.updateOperator(item.id, affected));
                    }
                    else {
                        return Promise.resolve();
                    }

                },

                //  on delete item
                onDeleteItem: ( proxy,item ) => {
                    return proxy.processRequest(TractorOperatorEndpoint.deleteOperator(item.id));
                }

            }
        });
    }

}

export default OperatorsAdmin;



// WEBPACK FOOTER //
// ./src/views/Operators/OperatorsAdmin.js